export function MessageWithoutQRURLButtonViewConstructor(services, callbacks, context, siteTypeConfig) {
  let joint = services.joint;
  return joint.shapes.html.AbstractElementView.extend({
    isElementEditable: true,
    isElementDeletable: true,
    editElementModalController: 'editMessageWithoutQRURLButtonController',
    editElementModalTemplate: require('./editMessageWithoutQRURLButton.modal.html'),
    angularTemplate: `
    <div layout="row" class="alc-ellipsis">
        {{elementData.title || 'parameters/quick_replies/message-without-qr-box/url_button' | translate}}
    </div>
`,
  });
}
